import { Component } from "react";

import { IMap } from "@/Common/Models/IMap";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

class GroupedComboBoxDropDownItem {
    constructor(GroupName: string, items: Immutable.List<ComboBoxDropDownItem>) {
        this.GroupName = GroupName;
        this.items = items;
    }

    public GroupName: string;
    public items: Immutable.List<ComboBoxDropDownItem>;
}

class ComboBoxDropDownItem {
    constructor(
        code: string,
        displayName: string,
        position: number = 0,
        groupName: string = null,
        originalItem: any = null,
        hidden: boolean = false
    ) {
        this.Code = code;
        this.DisplayName = displayName;
        this.Position = position;
        this.GroupName = groupName;
        this.OriginalItem = originalItem;
        this.Hidden = hidden;
    }

    public Code: string;
    public DisplayName: string;
    public Position: number;
    public GroupName: string;
    public OriginalItem: any;
    public Hidden: boolean;

    public static fromDictionary(obj?: IMap<string>, sortAlphabetically: boolean = true): ComboBoxDropDownItem[] {
        const dropDownItems = Object
            .keys(obj ?? {})
            .map(key => new ComboBoxDropDownItem(key, obj[key]));

        return sortAlphabetically
            ? dropDownItems.sortByProperty(x => x.DisplayName.toLowerCase())
            : dropDownItems;
    }
}

interface IComboboxProps {
    id: string;
    dataCy?: string;
    operation?: number;
    onChange?: (code: string) => void;

    selectedCode?: string;

    disabled?: boolean;
    HasEmptyItem?: boolean;

    items?: Immutable.List<ComboBoxDropDownItem>;

    className?: string;

    includeCodeInName?: boolean;

    operationArg1?: any;
    operationArg2?: any;
    operationArg3?: any;
    style?: React.CSSProperties;

    doInitialChangeOp?: boolean;
    maxNumberOptionCharacters?: number;

    showTooltips?: boolean;
    valid?: boolean;
}

/**
 * @deprecated Use ComboBoxControl component.
 */
class Combobox extends Component<IComboboxProps, never> {
    public render(): JSX.Element {
        var emptyComboBox = new ComboBoxDropDownItem("", "", -1, null);
        var selectedItemCode = this.props.selectedCode;
        if (selectedItemCode == null)
            selectedItemCode = "";

        var items: Immutable.List<ComboBoxDropDownItem> = null;
        var groupedItems: Immutable.List<GroupedComboBoxDropDownItem>;
        if (this.props.items != null && this.props.items.count() > 0) {
            items = this.props.items;
            groupedItems = items
                .groupBy((item: ComboBoxDropDownItem) => item.GroupName)
                .map((items, GroupName) => new GroupedComboBoxDropDownItem(GroupName, items.toList()))
                .sort((cur: GroupedComboBoxDropDownItem, next: GroupedComboBoxDropDownItem) => {
                    var G1 = cur.GroupName;
                    if (G1 == null)
                        G1 = "";

                    var G2 = next.GroupName;
                    if (G2 == null)
                        G2 = "";

                    if (G1 == G2)
                        return 0;
                    else
                        return G1.length > G2.length ? -1 : 1;
                }).toList();

            if (this.props.HasEmptyItem == true && groupedItems.size > 0) {
                items = items.push(emptyComboBox);
                if (groupedItems.get(0) != null) {
                    var nextlist = groupedItems.get(0).items.map(x => x).toArray();

                    nextlist.reverse().push(emptyComboBox);
                    groupedItems.get(0).items = Immutable.List(nextlist.reverse());
                }
            }
        }

        var Id = this.props.id;
        var className: string = "";
        if (this.props.className != null)
            className = this.props.className;

        var disabled: boolean = false;
        if (this.props.disabled) disabled = true;

        let style: React.CSSProperties = {};
        if (this.props.style != null)
            style = this.props.style;

        // Array of ComboBoxItem
        return (
            <select
                key={Id + "_select"}
                style={style}
                className={`form-control myle-control minimal ${className} ${this.props.valid === false ? "invalid" : ""}`}
                disabled={disabled}
                onChange={this.onChangeComboBox.bind(this)}
                title={this.props.items.find(p => p.Code === selectedItemCode)?.DisplayName ?? ""}
                value={selectedItemCode}
                data-cy={this.props.dataCy}
            >
                {groupedItems != null && groupedItems.count() > 1 && groupedItems.map((g: GroupedComboBoxDropDownItem) => (
                    <optgroup key={Id + "_" + g.GroupName} label={g.GroupName}>
                        {g.items != null &&
                                g.items.map((s: ComboBoxDropDownItem) => this.getComboBoxItemText(s, g, Id))
                        }
                    </optgroup>
                ))}
                {groupedItems != null
                    && groupedItems.count() == 1
                    && groupedItems.map((g: GroupedComboBoxDropDownItem) => g.items.map((s: ComboBoxDropDownItem) => this.getComboBoxItemText(s, g, Id)))
                }
            </select>
        );
    }

    private getComboBoxItemText(s: ComboBoxDropDownItem, g: GroupedComboBoxDropDownItem, id: string): JSX.Element {
        const value = this.props.includeCodeInName && !s.Code
            ? (s.Code + " - " + s.DisplayName)
            : s.DisplayName;

        return (
            <option
                key={id + "_" + g.GroupName + "_" + s.Code}
                value={s.Code}
                title={this.props.showTooltips ? value : ""}
                hidden={s.Hidden}
            >
                {this.props.maxNumberOptionCharacters && value.length > this.props.maxNumberOptionCharacters
                    ? limitTextLength(value, this.props.maxNumberOptionCharacters)
                    : value
                }
            </option>
        );
    }

    public componentDidMount(): void {
        var selectedItemCode = this.props.selectedCode;
        if (selectedItemCode == null)
            selectedItemCode = "";

        // pl says: why the fuck are we calling the "on change event of the combo box on load??" whatever state the combo box is in at first should be passed by the props and
        //          control should not need to update others about its initial state...
        //          adding a "don't do this props" to not do this, cause ain't got time to refactor everything

        if (this.props.doInitialChangeOp == null || this.props.doInitialChangeOp) {
            // DV - This is shit -- Added for a bug in FMP popup, remove it and retest fmp component that uses it
            // NR - Added for FMP bugfix
            // PL -  (╯°□°）╯︵
            if (this.props.selectedCode != null && this.props.selectedCode != undefined && this.props.selectedCode != "") {
                let _tmpSelected = this.props.items.filter(x => x.Code == this.props.selectedCode);
                if (_tmpSelected != null && _tmpSelected.count() > 0) {
                    selectedItemCode = _tmpSelected.get(0).Code;
                    setTimeout(() => {
                        console.warn("ComboReselect, default selected code doesnt exist", this.props.selectedCode, this.props.items);
                        this.ChangeComboBox(selectedItemCode);
                    }, 200);
                }
            }

            // DV - This is a protection that should throw an exception instead of trying to fix the problem itself. If the parent gave an invalid value for selectedCode, throw exception, don't trigger onchange for firstOrDefault selection. Its nice but its just hiding a deeper problem in the parent code.
            if (selectedItemCode == "" && this.props.HasEmptyItem == false && this.props.items.count() > 0) {
                selectedItemCode = this.props.items.get(0).Code;
                setTimeout(() => {
                    console.warn("ComboReselect, cannot select Empty value");
                    this.ChangeComboBox(selectedItemCode);
                }, 200);
            }
        }
    }

    public onChangeComboBox(e: React.ChangeEvent<HTMLSelectElement>): void {
        var selectedCode = e.target.value;
        this.ChangeComboBox(selectedCode);
    }

    public ChangeComboBox(selectedCode: string): void {
        var self = this;

        if (self.props.operation) {
            var operation = new LocalEvent(self.props.operation);
            operation.AddItem("value", selectedCode);
            operation.AddItem("id", self.props.id);
            operation.AddItem("arg1", self.props.operationArg1);
            operation.AddItem("arg2", self.props.operationArg2);
            operation.AddItem("arg3", self.props.operationArg3);
            LocalEventDispatcher.dispatch(operation);
        }

        if (self.props.onChange != null)
            self.props.onChange(selectedCode);
    }
}

export { Combobox, ComboBoxDropDownItem, GroupedComboBoxDropDownItem };
